import styled from "styled-components";
import { space, SpaceProps } from "styled-system";

export const List = styled.ul<SpaceProps>`
  ${space}
`;
